import { getId } from '../../util/data';
import { Loading } from '../../util/decorators';
import { omit } from '../../util/object';
import { apiCustomAdd, apiCustomDelete, apiCustomGet, apiCustomUpdate, apiFileUpload, type Custom } from '../api';

export const isEdit = (record: unknown) => Boolean(record && (<any>record).isEdit);

export interface IDataSource extends Omit<Custom, 'content'> {
  isEdit?: boolean;
  content?: Custom['content'];
}

export class CustomService {
  dataSource: IDataSource[] = [];

  dataSourceLoading = false;

  @Loading<CustomService>(['dataSourceLoading'])
  async requestDataSource() {
    const { data } = await apiCustomGet();
    this.dataSource = data;
  }

  add() {
    this.dataSource.unshift({ id: getId(), type: 'custom' } as IDataSource);
  }

  async upsert(record: Partial<IDataSource> & { id: IDataSource['id']; }, file?: Blob) {
    if (file) {
      const { data } = await apiFileUpload(file);
      record.content = data;
    }
    if (record.id >= 0) {
      await apiCustomUpdate(record);
    } else {
      await apiCustomAdd(omit(record, ['id']) as Custom);
    }
  }

  async del(id: IDataSource['id']) {
    if (id >= 0) await apiCustomDelete(id);
    this.dataSource.splice(this.dataSource.findIndex(_ => _.id === id), 1);
  }

  @Loading<CustomService>(['dataSourceLoading'])
  async fillContent(ids: IDataSource['id'][]) {
    await Promise.allSettled(ids.map(async id => {
      const { data } = await apiCustomGet({ id });
      const record = this.dataSource.find(_ => _.id === id);
      if (record) record.content = data.content;
    }));
  }
}

export const customService = new CustomService();